import React from "react";
import classNames from "classnames";
import { LoadingSpinnerProps } from "./LoadingSpinner.types";
import styles from "./LoadingSpinner.module.scss";
import { SpinnerIcon } from "@/components/Icon/IconSvgMap";

/**
 * LoadingSpinner 组件 - 独立的 SVG 加载动画
 * 可用于各种加载场景
 * 设计来自 Figma: 带白色边框和渐变背景的圆角方形容器
 */
export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 40,
  className,
}) => {
  return (
    <div className={classNames(styles.container, className)}>
      <div className={styles.spinner}>
        <SpinnerIcon width={size} height={size} className={styles.loadingSvg} />
      </div>
    </div>
  );
};

export default LoadingSpinner;
